import decode from "jwt-decode";

import cookie from "./cookie.js";

const jwt = {
	getToken: () => cookie.get("_mycookie"),
	setToken: (token) => token && cookie.set("_mycookie", token),
	destroyToken: () => {
		cookie.remove("_mycookie");
	},
	isAuthenticated: () => {
		const token = cookie.get("_mycookie");
		return token && token !== "undefined";
	},
	// Safe, non-redirecting read of the display name (username, else email) from the token; null when absent or malformed
	getUsername: () => {
		const token = cookie.get("_mycookie");
		if (!token || token === "undefined") return null;
		try {
			const { username, email } = decode(token);
			return (typeof username === "string" && username.trim()) || (typeof email === "string" && email.trim()) || null;
		} catch {
			return null;
		}
	},
	decode: () => {
		const token = cookie.get("_mycookie");
		if (token) return decode(token);
		cookie.remove("_mycookie");
		window.location.href = "/";
		return null;
	},
};

export default jwt;
